<div class="card">
  <div class="card-header">
    <div class="float-start">
      <h5 class="card-title" >Filtri</h5>
      <h6 class="card-subtitle text-muted" data-bs-toggle="collapse" href="#filterDiv" role="button" aria-expanded="false" aria-controls="filterDiv">Apri/chiudi filtri</h6>
    </div>
    <button type="button" class="btn btn-secondary float-end fw-bold ms-2" (click)="cleanFilter()" data-bs-toggle="tooltip" data-bs-placement="top" title="Pulisci filtro">
      <i class="mdi mdi-update"></i><span class="d-none d-lg-inline-block">Pulisci filtro</span>
    </button>

    <button type="button" class="btn btn-info float-end fw-bold" (click)="filterTable()" data-bs-toggle="tooltip" data-bs-placement="top" title="Ricerca">
      <i class="dripicons-search"></i><span class="d-none d-lg-inline-block">Ricerca</span>
    </button>
  </div>
  <div class="card-body collapse" id="filterDiv">
    <div class="row g-3">
      <div class="col-6">
        <label for="nome-file" class="form-label">Nome file</label>
        <input type="text" class="form-control" id="nome-file" placeholder="" value=""/>
      </div>
      <div class="col-6">
        <label for="stato-caricamento" class="form-label">Stato caricamento</label>
        <select class="form-select" id="stato-caricamento">
          <option value="-1">Tutti</option>
          <option *ngFor="let item of uniqueStatus" value="{{ item }}">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="col-6">
        <label for="data-caricamento-from" class="form-label">Data caricamento da</label>
        <div class="input-group">
          <input type="date" class="form-control" id="data-caricamento-from" />
        </div>
      </div>

      <div class="col-6">
        <label for="data-caricamento-to" class="form-label">Data caricamento a</label>
        <input type="date" class="form-control" id="data-caricamento-to" />
      </div>

      <div *ngIf="user.isAdmin()" class="col-6">
        <label for="gruppo" class="form-label">Gruppo</label>
        <select class="form-select" id="gruppo">
          <option value="-1">Tutti</option>
          <option *ngFor="let item of uniqueGroups" value="{{ item }}">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
